import { changeDecimalString } from 'utils/formatting_utils';

const TableCellDecimalFormatter = ({ value, maxLength, digits, component, prefix }) => {
	const decimalValue = changeDecimalString(value, maxLength, digits, component, prefix, true);

	return (
		<span className="table-cell__content" tabIndex="0">{decimalValue}</span>
	);
};

export default TableCellDecimalFormatter;
